/* eslint-disable no-unused-expressions */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  setCodeTableSuccessMessage,
  setDataChangeTried,
  setSelectedParentProtectedInd,
  updateParentUserId,
} from '../store/actions';
import CodeTableCustomTextField from './CodeTableCustomTextField';
import { CODE_DOMAIN_CELL_HEAD } from './tableHead';

const CodeDomainTable = ({
  rebateCodeSerchResult,
  fullScreen,
  setFullScreen,
  onParentKeySelection,
  isReadOnly,
}) => {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  // const [paramsStore, setParamsStore] = React.useState();
  // const onGridReady = (params) => {
  //   setParamsStore(params);
  //   if (rebateCodeSerchResult && rebateCodeSerchResult?.length > 0) {
  //     params.api.forEachNode(
  //       (node) => node.rowIndex === 0 && node.setSelected(true)
  //     );
  //   }
  // };
  // useEffect(() => {
  //   paramsStore &&
  //     paramsStore.api.forEachNode(
  //       (node) => node.rowIndex === 0 && node.setSelected(true)
  //     );
  // }, [paramsStore]);
  // useEffect(() => {
  //   if (rebateCodeSerchResult && rebateCodeSerchResult?.length > 0) {
  //     paramsStore &&
  //       paramsStore.api.forEachNode(
  //         (node) => node.rowIndex === 0 && node.setSelected(true)
  //       );
  //   }
  // }, [rebateCodeSerchResult]);
  const handleBlur = (props, compareData) => {
    if (props && !props.data.isNewRecord) {
      const index = compareData.findIndex(
        (item) => item.codeDomainKey === props.data.codeDomainKey
      );

      if (index !== -1) {
        const result = compareData[index];

        if (
          props.data.longDescription !== result.longDescription ||
          props.data.shortDescription !== result.shortDescription ||
          props.data.valuesProtectedInd !== result.valuesProtectedInd
        ) {
          dispatch(updateParentUserId(index, logInUser));
        } else {
          dispatch(updateParentUserId(index, result.lastUpdateUserId));
        }
      }
    }
    dispatch(setDataChangeTried(Math.random()));
    dispatch(setCodeTableSuccessMessage(''));
  };

  const handleFullScreenView = () => {
    setFullScreen(!fullScreen);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.codeDomainKey;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({ CODE_DOMAIN_KEY: selectedRow });
    }
  };

  const onRowSelect = (event) => {
    dispatch(setSelectedParentProtectedInd(event?.data?.valuesProtectedInd));
    onParentKeySelection(event.data);
  };

  return (
    <div
      className={`table-container fourRecords no-border mt-${
        fullScreen ? 1 : 3
      }`}
    >
      <Grid
        gridHeight={fullScreen ? '70vh' : 400}
        //onGridReady={onGridReady}
        rowData={rebateCodeSerchResult}
        defaultCol={{ editable: false }}
        columnDefs={CODE_DOMAIN_CELL_HEAD}
        onSelect={onRowSelect}
        frameworkComponents={{
          textFieldComponent: (props) => (
            <CodeTableCustomTextField
              {...props}
              validateBtnDisable={handleBlur}
              isReadOnly={isReadOnly}
            />
          ),
        }}
        fullScreenView={fullScreen}
        handleFullScreenViewClick={handleFullScreenView}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        handleViewHistory={handleViewHistory}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        exportFile
        data-testid="onEditingStopped"
        fileName="Code Domain"
      />
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CODE_DOMAIN"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
};

export default CodeDomainTable;
